var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none"},[_c('v-idle',{attrs:{"loop":false,"reminders":[60, 120],"wait":5,"duration":3000,"events":['mousemove', 'keypress', 'scroll']},on:{"idle":_vm.onidle,"remind":_vm.onremind}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }